import { StorageManager } from 'src/app/common/storage-manager.class';
import { FormRequestTypes } from 'src/app/common/classes/form-request';

import {
  Form,
  FormField,
  FormSection,
  FormType,
} from 'src/app/common/components/reactive-form-builder/interfaces/form.interface';
import {
  InputType,
} from 'src/app/common/components/reactive-form-builder/interfaces/input.interface';
import { PlanAbonadoEnvironmentDefinition } from '../../environment-variables';
import { FertirrigacionModel } from 'src/app/models/tareas/fertirrigacion.model';
import { PlanAbonadoListsDefinition } from './list-variables';
import { PlanAbonadoModel } from 'src/app/models/tareas/plan-abonado.model';

export class PlanAbonadoFormDefinition {
  public formType!: FormType;

  public env: PlanAbonadoEnvironmentDefinition =
    new PlanAbonadoEnvironmentDefinition();

  public lists: PlanAbonadoListsDefinition =
    new PlanAbonadoListsDefinition();

  public formFields!: Form<PlanAbonadoModel>;

  public fieldNames: FormField<any>[] = [];

  public fieldLabels: string[] = [];

  public lastFieldEdited = '';

  public tag = '';

  public requestType: FormRequestTypes = FormRequestTypes.CREATE;

  public cliente = StorageManager.getClient();

  public usuario = StorageManager.getUser();

  public model: PlanAbonadoModel = {
    id_cliente: this.cliente?.id,
    id_usuario: +StorageManager.getUser().id,
  };

  public horaInicio = '';

  public horaFin = '';

  public now = new Date();

  public getFormFields(): FormField<any>[] {
    const formFields: FormField<any>[] = [
      {
        name: 'programa_calculo',
        vinculatedFields: undefined,
        label: 'Programa Cálculo',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        order: 1
      },
      {
        name: 'necesidad_uf_n',
        vinculatedFields: undefined,
        label: 'Necesidad UF N (Kg/Ha)',
        input: { type: InputType.NUMERIC, isEditable: true },
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        order: 2
      },
      {
        name: 'necesidad_uf_p205',
        vinculatedFields: undefined,
        label: 'Necesidad UF P205 (Kg/Ha)',
        input: { type: InputType.NUMERIC, isEditable: true },
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        order: 3
      },
      {
        name: 'necesidad_uf_k20',
        vinculatedFields: undefined,
        label: 'Necesidad UF K20 (Kg/Ha)',
        input: { type: InputType.NUMERIC, isEditable: true },
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        order: 4
      },
      {
        name: 'objetivo_produccion',
        vinculatedFields: undefined,
        label: 'Objetivo Producción (Kg/Ha)',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        order: 5
      },
      {
        name: 'id_cultivo',
        vinculatedFields: undefined,
        label: 'Cultivo',
        input: {
          type: InputType.DROPDOWN_SEARCH,
          isEditable: true,
          data: this.lists.cultivos,
          dropdownConfiguration: {
            valuePrimaryKey: 'id'
          }
        },
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        order: 6
      },
      {
        name: 'uso_herramienta',
        vinculatedFields: undefined,
        label: 'Uso de Herramienta',
        input: {
          type: InputType.SWITCH,
          isEditable: true,
        },
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        order: 7
      },
      {
        name: 'codigo_regfer',
        vinculatedFields: undefined,
        label: 'Código REGFER',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        order: 8
      },
      {
        name: 'fecha_asesoramiento',
        vinculatedFields: undefined,
        label: 'Fecha Elaboración Plan Abonado',
        input: { type: InputType.CALENDAR, isEditable: true },
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        order: 9
      },
    ];

    this.fieldNames = this.fieldNames.concat(
      formFields.filter((it) => it.conditions.isVisible)
    );
    this.fieldLabels = this.fieldLabels.concat(
      formFields.filter((it) => it.conditions.isVisible).map((it) => it.label)
    );
    return formFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }

  private getFormSections(): FormSection<FertirrigacionModel>[] {
    const sections: FormSection<FertirrigacionModel>[] = [
      {
        name: '',
        width: 12,
        isVisible: true,
        fields: this.getFormFields(),
        order: 1,
      },
      {
        name: '',
        width: 6,
        isVisible: true,
        fields: this.getHiddenFields(),
        order: 2,
      },
    ];

    return sections.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }

  private getHiddenFields(): FormField<any>[] {
    const hiddenFields: FormField<any>[] = [
      {
        name: 'id',
        vinculatedFields: undefined,
        label: '',
        input: {
          type: InputType.HIDDEN,
          defaultValue: this.model.id,
          isEditable: false,
        },
        width: 2,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        order: 1,
      },
      {
        name: 'id_cliente',
        vinculatedFields: undefined,
        label: '',
        input: {
          type: InputType.HIDDEN,
          defaultValue: this.cliente?.id ?? '',
          isEditable: false,
        },
        updateValue: () => this.cliente?.id ?? '',
        width: 2,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.hasClients && this.env.userCanSeeClientes,
        },
        order: 2,
      },
      {
        name: 'id_usuario',
        vinculatedFields: undefined,
        label: '',
        input: {
          type: InputType.HIDDEN,
          defaultValue: this.formType !== FormType.EDITION ? this.usuario?.id ?? '' : '',
          isEditable: false,
        },
        updateValue: () => this.formType !== FormType.EDITION ? this.usuario?.id ?? '' : '',
        width: 2,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        order: 3,
      },
      {
        name: 'cultivo',
        vinculatedFields: undefined,
        label: '',
        input: { type: InputType.HIDDEN, isEditable: false },
        width: 2,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        updateValue: () => this.lists.cultivos.selected?.cultivo,
        order: 4,
      },
    ];

    return hiddenFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }

  constructor(
    type: FormRequestTypes,
    _model: Record<string, string>,
    table: (string[] | string[][])[] | null
  ) {
    this.formType = +type;

    this.formFields = {
      name: 'plan-abonado',
      type: this.formType,
      sections: this.getFormSections(),
      table: { title: '', showIndex: false, data: table?.[0], style: table?.[1] },
      uploadButton: false,
      signed: false,
    };
  }
}
